import React, { useState, useEffect } from 'react';

const SystemClock: React.FC = () => {
  const [currentTime, setCurrentTime] = useState<string>('');
  const [offsetHours, setOffsetHours] = useState<number>(0);

  useEffect(() => {
    // Загружаем offset часового пояса
    const fetchOffset = async () => {
      try {
        const response = await fetch('/api/v1/system-settings/current-time');
        if (response.ok) {
          const data = await response.json();
          setOffsetHours(data.offset_hours || 0);
        }
      } catch (error) {
        console.error('Ошибка загрузки времени:', error);
      }
    };

    fetchOffset();
  }, []);

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;
      const localTime = new Date(utcTime + offsetHours * 3600000);

      const hours = localTime.getHours().toString().padStart(2, '0');
      const minutes = localTime.getMinutes().toString().padStart(2, '0');

      setCurrentTime(`${hours}:${minutes}`);
    };

    updateClock();
    const intervalId = setInterval(updateClock, 1000);

    return () => clearInterval(intervalId);
  }, [offsetHours]);

  if (!currentTime) return null;

  return (
    <span className="font-mono text-xs text-gray-400 dark:text-gray-500">
      {currentTime}
    </span>
  );
};

export default SystemClock;
